import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import styles from "../commanstyles.module.css";
import FinanialStatmentStandlone from "./FinanialStatmentStandlone";
import FinanialStatmentsConsolidated from "./FinanialStatmentsConsolidated";
import Auditor from "./Auditor";
import LLPStatementOfAccount from "./LLPStatementOfAccount";
import LLPCertifier from "./LLPCertifier";
import { SuccessSwal, warningSwal } from "../../../Util/Toast";
import {
  getfinacialdata,
  getLLPfinacialdata,
  getAboutTheCompany,
} from "../../../Services/APIrequests";
import { IoMdLock } from "react-icons/io";

const Financialdata = ({ isSubScribe, refreshLoading }) => {
  const { financialType, cin } = useParams();
  const [activeTab, setActiveTab] = useState(financialType || "");
  const [companyClass, setCompanyClass] = useState(null);

  const [financialData, setfinancialData] = useState([]);
  const [standaloneData, setStandaloneData] = useState([]);
  const [certifiers, setCertifiers] = useState([]);
  const [consolidatedData, setConsolidatedData] = useState([]);
  const [standaloneDataAuditor, setStandaloneDataAuditor] = useState([]);
  const [consolidatedDataAuditor, setConsolidatedDataAuditor] = useState([]);
  const [costData, setCostData] = useState([]);
  const [statutoryData, setStatutoryData] = useState([]);
  const [secretarialData, setSecretarialData] = useState([]);

  useEffect(() => {
    if (refreshLoading == false) {
      fetchFinancialData();
    }
  }, [cin, refreshLoading]);

  useEffect(() => {
    if (companyClass === "LLP") {
      setActiveTab("STATEMENT OF ACCOUNT");
    } else if (companyClass !== null && !financialType) {
      setActiveTab("Financial Statements - Standalone");
    }
  }, [companyClass, financialType]);

  const fetchFinancialData = async () => {
    try {
      const aboutRes = await getAboutTheCompany(cin);
      const classFromAPI = aboutRes?.data?.aboutTheCompany?.Company_Class;
      setCompanyClass(classFromAPI);

      let response;
      if (classFromAPI === "LLP") {
        response = await getLLPfinacialdata(cin);
      } else {
        response = await getfinacialdata(cin);
      }

      if (response?.data) {
        setfinancialData(response.data.financialData || [])
        setCertifiers(response.data.certifiers || []);
        setCostData(response.data.Cost || []);
        setStatutoryData(response.data.Statutory || []);
        setSecretarialData(response.data.Secretarial || []);
        setStandaloneData(response.data.Standalone || []);
        setConsolidatedData(response.data.Consolidated || []);

        setStandaloneDataAuditor(response.data.Standalone?.[0]?.Company_Auditors || []);
        setConsolidatedDataAuditor(response.data.Consolidated?.[0]?.Company_Auditors || []);
      } else {
        warningSwal("Error", "No financial details found in response");
      }
    } catch (error) {
      console.error("Failed to fetch financial data:", error);
    }
  };

  const renderTableContent = () => {
    if (!isSubScribe) return null;

    if (companyClass === "LLP") {
      switch (activeTab) {
        case "STATEMENT OF ACCOUNT":
          return (
            <LLPStatementOfAccount
              isSubScribe={isSubScribe}
              apiData={financialData}
            />
          );
        case "CERTIFIER(S)":
          return (
            <LLPCertifier
              apiData={certifiers}
              isSubScribe={isSubScribe}
            />
          );
        default:
          return null;
      }
    } else {
      switch (activeTab) {
        case "Financial Statements - Standalone":
          return (
            <FinanialStatmentStandlone
              isSubScribe={isSubScribe}
              apiData={standaloneData}
              setStandaloneData={setStandaloneData}
            />
          );
        case "Financial Statements - Consolidated":
          return (
            <FinanialStatmentsConsolidated
              isSubScribe={isSubScribe}
              apiData={consolidatedData}
            />
          );
        case "Auditor(s)":
          return (
            <Auditor
              isSubScribe={isSubScribe}
              apiData={standaloneDataAuditor}
              apiData2={consolidatedDataAuditor}
              costData={costData}
              statutoryData={statutoryData}
              secretarialData={secretarialData}
            />
          );
        default:
          return null;
      }
    }
  };

  const Financial_llps = ["STATEMENT OF ACCOUNT", "CERTIFIER(S)"];
  const Financial_companys = [
    "Financial Statements - Standalone",
    "Financial Statements - Consolidated",
    "Auditor(s)",
  ];

  return (
    <div className={styles.structure_container}>
      <div className={styles.Compilance_container}>
        <div className={styles.finace_subcontainer}>
          <div className={styles.finac_box}>
            {(companyClass === "LLP" ? Financial_llps : Financial_companys).map((item) => (
              <div
                key={item}
                className={`${styles.finac_box_text_container} ${activeTab === item ? styles.Active_subTab : ""
                  }`}
                onClick={() => setActiveTab(item)}
              >
                <h4 className={styles.finac_box_header}>{item}</h4>
              </div>
            ))}
          </div>
        </div>
      </div>

      {!isSubScribe && (
        <button className={styles.Subscription_msg}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {renderTableContent()}
    </div>
  );
};

export default Financialdata;
